"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _withStyles = _interopRequireDefault(require("elevate-ui/withStyles"));

var _AddCircleOutline = _interopRequireDefault(require("elevate-ui-icons/AddCircleOutline"));

var _excluded = ["classes", "className", "theme"];

//$FlowIgnore
var Placeholder = function Placeholder(_ref) {
  var classes = _ref.classes,
      className = _ref.className,
      theme = _ref.theme,
      rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    className: (0, _classnames["default"])(classes.root, className)
  }, rest), /*#__PURE__*/_react["default"].createElement(_AddCircleOutline["default"], {
    color: theme.colors.gray800,
    size: 20
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: classes.text
  }, "Add Component"));
};

var styles = function styles(theme) {
  return {
    root: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      cursor: "pointer",
      background: "rgba(0, 85, 172, 0.1)",
      padding: "8px",
      border: "1px dashed rgba(0, 85, 172, 0.5)"
    },
    text: {
      fontSize: "12px",
      lineHeight: "20px",
      fontWeight: "600",
      color: theme.colors.gray800,
      textAlign: "center"
    }
  };
};

var _default = (0, _withStyles["default"])(styles)(Placeholder);

exports["default"] = _default;